import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import ProblemsSection from "@/components/ProblemsSection";
import SolutionsSection from "@/components/SolutionsSection";
import ChannelsSection from "@/components/ChannelsSection";
import DifferentiatorsSection from "@/components/DifferentiatorsSection";
import SecuritySection from "@/components/SecuritySection";
import CTAFinal from "@/components/CTAFinal";
import Footer from "@/components/Footer";

const LandingPage = () => {
  const navigate = useNavigate();
  const goToForm = () => navigate("/solicitar-demonstracao");

  const handleScrollToSolutions = () => {
    document
      .getElementById("solucoes")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="App relative">
      <Header onRequestDemo={goToForm} />
      <main>
        <Hero
          onRequestDemo={goToForm}
          onScrollToSolutions={handleScrollToSolutions}
        />
        <ProblemsSection />
        <SolutionsSection onRequestDemo={goToForm} />
        <ChannelsSection />
        <DifferentiatorsSection />
        <SecuritySection />
        <CTAFinal
          onRequestDemo={goToForm}
          onSpeakSpecialist={goToForm}
        />
      </main>
      <Footer onRequestDemo={goToForm} />
    </div>
  );
};

export default LandingPage;
